import { TYPO } from "styles/Typo";
import { AmountInput, AmountInputHelper, SurveyTitle } from "../component";
import { SAA_SURVEY_META } from "utils/constant/STATUS";

interface Step1Props {
  handleMonthSavings: (option: number) => void;
  saving_amount_monthly: number | null;
  expenseCategory?: string;
  type: "retire" | "consume";
}

export default function Step1({
  handleMonthSavings,
  saving_amount_monthly,
  expenseCategory,
  type,
}: Step1Props) {
  const label =
    type === "consume"
      ? SAA_SURVEY_META["expense_category"][expenseCategory ?? ""]?.label
      : "노후 자금";
  const josa = require("josa-js");
  return (
    <div className="bg-background relative w-full   ">
      {/* Question Container */}
      <div className="content-stretch flex flex-col items-start justify-start w-full">
        <div className="w-full ">
          <div className="pt-4 px-6 space-y-1">
            <p className={`${TYPO.TYPO7_MD} text-blue50`}>{label}에 쓸 돈을</p>
            <p
              className={` w-full text-[26px] leading-[140%] font-[600]  text-gray90 whitespace-pre-line`}
            >
              매달 얼마씩 모을 수 있나요?
            </p>
          </div>

          <div className="px-6 py-4 space-y-[10px]">
            <AmountInput
              value={saving_amount_monthly}
              setValue={handleMonthSavings}
              dataGtmId="saa-survey-monthly-amount-input"
            />

            <AmountInputHelper
              setValue={handleMonthSavings}
              units={[10, 50, 100]}
              value={saving_amount_monthly || 0}
              dataGtmId="saa-survey-monthly-amount-input-helper"
            />
          </div>
        </div>
        <div className="px-6 py-4"></div>
      </div>
    </div>
  );
}
